module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-392.73be7e9.woff2";